import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import './css/bootstrap.min.css'
import './css/font-awesome.min.css'
import './css/elegant-icons.css'
import './css/magnific-popup.css'
import './css/slicknav.min.css'
import './css/style.css'

import App from './App';
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
